module.exports = __webpack_public_path__ + "img/146.39278cc7.jpg";